import React, {useRef, useState} from "react";
import Button from "components/v2/button/button";
import InputField from "components/v2/input-field/input-field";
import LoadingProgress from "components/loading-progress/loading-progress";
import "./style.scss";
import { Link } from "react-router-dom";
import { submitLenderRegistration } from "redux/actions/lenderRegistrationAction";
import { getMessageID } from "helpers/utils";
import languageSpecificTexts from "./language-specific-texts";
import Recaptcha from "react-google-recaptcha";

const messageTypeSuccess = "success";
const messageTypeError = "error";

const LenderRegistrationForm = ({language, onComplete}) => {
    const [validationErrors, setValidationErrors] = useState({
        name: "",
        email: "",
        contactNumber: "",
        captchaValue: ""
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const siteKey = process.env.REACT_APP_RECAPTCHA_KEY;
    const recaptchaRef = useRef();

    const texts = languageSpecificTexts[language]

    return (
        <div className="lender-registration-form">
            {loading && <LoadingProgress />}
            <div className="close-button" onClick={onComplete}><i className="fas fa-times" /></div>
            <div className="heading">{texts.heading}</div>
            <MessageDisplay visible={!!message} message={message}/>
            <div className="sub-heading">{texts.subHeading}</div>
            <div className="label">{texts.labelName}</div>
            <InputField 
                attributes = {{
                    placeholder:texts.namePlaceholder,
                    id:"lenderRegistrationFormNameField",
                    name:"name",
                    required: true,
                    maxLength: 100,
                }}
                modifier={{error: validationErrors.name}}
            />

            <div className="label">{texts.labelEmail}</div>
            <InputField  
                attributes = {{
                    placeholder:"E.g.: lender123@gmail.com", 
                    id:"lenderRegistrationFormEmailField", 
                    name: "email",
                    required: true,
                    maxLength: 50,
                    pattern: "/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/"
                }}
                modifier={{error: validationErrors.email}}
            />

            <div className="label">{texts.labelContactNumber}</div>
            <InputField  attributes = {{
                    placeholder:"E.g. : 9847XXXXXXX", 
                    id:"lenderRegistrationFormContactNumberField", 
                    name:"contactNumber",
                    required: true,
                    maxLength: 13,
                    pattern: "/^[1-9]\d{9,12}$/"
                }}
                modifier={{error: validationErrors.contactNumber}}
            />
            <div className="label">{texts.labelRecaptcha}</div>
            <div className="recaptcha input-container ">                    
                <Recaptcha
                    sitekey={siteKey}
                    ref={recaptchaRef}
                />
                {validationErrors.captchaValue ? (
                    <small className="has-error">{validationErrors.captchaValue}</small>
                ) : (
                    null
                )}
            </div>
            <div className="action-container">
                <Link onClick={(e)=>{
                    e.preventDefault();
                    handleSubmit(setValidationErrors, setLoading, setMessage, onComplete, texts, recaptchaRef)
                    recaptchaRef.current.reset();
                }}>
                    <Button modifier={{className: "submit-button"}} on>{texts.submitButtonText}</Button>
                </Link>
            </div>
        </div>
    )
}


async function handleSubmit(setValidationErrors, setLoading, setMessage, onComplete, texts, recaptchaRef) {
    
    const name = document.getElementById("lenderRegistrationFormNameField").value
    const email = document.getElementById("lenderRegistrationFormEmailField").value
    const contactNumber = document.getElementById("lenderRegistrationFormContactNumberField").value
    const captchaValue = recaptchaRef.current.getValue()

    const validationErrors = {
        name: "",
        email: "",
        contactNumber: "",
        captchaValue: ""
    }
    let isValid = true;
    if(!isValidEmail(email)) {
        validationErrors.email = texts.emailValidationError
        isValid = false
    }
    if(!isValidPhoneNumber(contactNumber)) {
        validationErrors.contactNumber = texts.contactNumberValidationError
        isValid = false
    }
    if(!isValidName(name)) {
        validationErrors.name = texts.nameValidationError
        isValid = false
    }
    if(!isValidCaptcha(captchaValue)) {
        validationErrors.captchaValue = texts.captchaValidationError
    }

    setValidationErrors(validationErrors)
    if(!isValid) {
        return
    }
    setLoading(true)
    submitLenderRegistration({full_name: name, email, phone_number: contactNumber, msg_id: getMessageID()}, captchaValue)
    .then((response) => {
        setMessage({type: messageTypeSuccess, text: texts.successMessage})
        setTimeout(()=>{
            onComplete()
        }, 6000)
        setLoading(false)
    }).catch((error) => {
        setMessage({
            type: messageTypeError, 
            text: error.response && error.response.data && error.response.data.response_message
        })
        setTimeout(()=>{
            setMessage(null)
        }, 6000)    
        setLoading(false)
    })
}

function isValidEmail(value) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = regex.test(value)
    return isValid
}
  
function isValidPhoneNumber(value) {
    //string of digits with 10-13 length
    const regex = /^[1-9]\d{9,12}$/
    const isValid = regex.test(value)
    return isValid
}

// A valid name contains only alphabets and spaces and numbers. and max length is 100.
// A valid name should not contain special characters.
function isValidName(value) {
    const regex = /^(?!\s*$)[a-zA-Z0-9\s]{1,100}$/;
    const isValid = regex.test(value);
    return isValid;
}

function isValidCaptcha(value) {
    return value != ""
}

function MessageDisplay({message, visible}) {
    const {type, text} = message || {}
    return (
        <div className={`message-display ${visible? 'show' : ''} ${type}`}>{text}</div>
    )
}
export default LenderRegistrationForm;